
import { Button } from 'antd';
import styled from 'styled-components';
import {SyncOutlined} from '@ant-design/icons'

const ButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: #1c7074;
    border-color: #1c7074;

    &:hover {
        color: white;
        background-color: #2b979d;
    }
  }
`;

interface PropsInterface {
    text: string;
    onClick?: any;
    disabled?: boolean;
}

export default function ButtonRefresh(props: PropsInterface) {
    return (
        <ButtonContainer>
            {props.disabled
                ? <Button disabled>{props.text} icon={<SyncOutlined/>}</Button>
                : <Button onClick={props.onClick} type="primary"icon={<SyncOutlined />}>{props.text}</Button>
            }
        </ButtonContainer>
    )
}